import { Linkedin, Instagram } from "lucide-react";
import { TID, LOGO_URL, CONTACT_PHONES, CONTACT_EMAILS, WHATSAPP_NUMBER } from "@/lib/testIds";
import DpiitBadge from "./DpiitBadge";
import TextReveal from "./TextReveal";

const LINKS = [
  { href: "/#services", label: "Services" },
  { href: "/#case-studies", label: "Case Studies" },
  { href: "/#why", label: "Why Us" },
  { href: "/#about", label: "About" },
  { href: "/changelog", label: "Changelog" },
  { href: "/#contact", label: "Contact" },
];

export const Footer = () => (
  <footer
    data-testid={TID.footer.root}
    className="relative bg-navy text-white noise overflow-hidden"
  >
    <div aria-hidden className="absolute -top-40 right-0 h-[520px] w-[520px] rounded-full bg-[color:var(--violet)]/35 blur-[160px]" />
    <div aria-hidden className="absolute -bottom-40 -left-40 h-[520px] w-[520px] rounded-full bg-[color:var(--gold)]/18 blur-[150px]" />

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 pt-20 pb-10">
      {/* Big wordmark */}
      <div className="border-b border-white/10 pb-10">
        <p className="font-serif text-[16vw] md:text-[10vw] leading-[0.9] tracking-tighter text-white/90">
          msme<span className="italic text-[color:var(--gold)]">money</span>.
        </p>
        <p className="mt-4 max-w-lg text-white/60 text-sm md:text-[15px]">
          <TextReveal>
            India's trusted partner for MSME subsidies, debt recovery and project funding. Backed by advocates. Recognized by DPIIT.
          </TextReveal>
        </p>
      </div>

      <div className="grid grid-cols-12 gap-8 py-14">
        <div className="col-span-12 md:col-span-4">
          <img src={LOGO_URL} alt="MSMEmoney" className="h-7 w-auto" />
          <p className="mt-6 text-sm text-white/60 max-w-xs">
            A venture of <span className="text-white">Sera One Pvt. Ltd.</span>
            <br />
            Panipat · Sonipat · Gurugram · Pan-India
          </p>
          <div className="mt-6">
            <DpiitBadge variant="dark" />
          </div>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50">
            Navigate
          </p>
          <ul className="mt-5 space-y-3">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="font-serif text-lg text-white/85 hover:text-[color:var(--gold)] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50">
            Contact
          </p>
          <ul className="mt-5 space-y-2.5 text-[13px] text-white/80">
            {CONTACT_PHONES.map((p) => (
              <li key={p} className="whitespace-nowrap">
                <a href={`tel:${p.replace(/\s+/g, "")}`} className="hover:text-[color:var(--gold)]">
                  {p}
                </a>
              </li>
            ))}
            {CONTACT_EMAILS.map((e) => (
              <li key={e} className="whitespace-nowrap">
                <a href={`mailto:${e}`} className="hover:text-[color:var(--gold)] text-[12.5px]">
                  {e}
                </a>
              </li>
            ))}
            <li className="whitespace-nowrap">
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-[color:var(--gold)]"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div className="col-span-12 md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50">
            Follow
          </p>
          <div className="mt-5 flex gap-3">
            <a
              href="#"
              aria-label="LinkedIn"
              className="grid h-10 w-10 place-items-center border border-white/15 text-white/80 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="#"
              aria-label="Instagram"
              className="grid h-10 w-10 place-items-center border border-white/15 text-white/80 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 border-t border-white/10">
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/50">
          © {new Date().getFullYear()} Sera One Pvt. Ltd. · MSMEmoney.ai · All
          rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
